
import {defineComponent} from "vue";
import {CityResponse} from "@/services/city/types";
import * as CityService from "@/services/city"
import TipInput from "@/components/TipInput.vue";

export default defineComponent({
  name: "CityList",
  components: {TipInput},
  data: ()=>({
    cityList: null as null | CityResponse,
    searchCity: ""
  }),
  watch: {
    searchCity() {
      window.location.href = this.path
    }
  },
  computed: {
    cityCode() {
        return this.$route.params.cityCode
    },
    path(): string{
      return this.$router.resolve({
        name: 'cityView',params: {page: this.$route.params.page || 'excursions',cityCode: this.searchCity}}).fullPath;
    },
    currentCity(){
      const cityCode = this.$route.params.cityCode as string;
      if(this.cityList && cityCode in this.cityList){
        return this.cityList[cityCode]
      }
      return "всему миру";
    }
  },
  async mounted() {
    this.cityList = await CityService.index();
  },

})
